<template>
  <div class="wh100">
      <xh-filter-layout title="六朵云">
          <template slot="filter">
              <el-form :inline="true" size="medium">
                  <el-form-item>
                      <el-select v-model="form.cloud_type" placeholder="请选择" clearable>
                          <el-option v-for="item in CloudType" :key="item.dictionary_code" :label="item.dictionary_name" :value="item.dictionary_code"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                      <el-button class="el-icon-plus" type="primary" @click="edit(null)">添加</el-button>
                  </el-form-item>
              </el-form>
          </template>
          <template #content>
              <MyTable ref="mytable" :url="table.url" :params="form" :method="table.method" stripe border fit :customSort="true">
                  <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                  <el-table-column prop="cloud_type_name" label="类型" align="center" sortable></el-table-column>
                  <el-table-column prop="system_name" label="名称" align="center" sortable></el-table-column>
                  <el-table-column prop="sort" label="排序" align="center" width="90" sortable></el-table-column>
                  <el-table-column label="操作" align="center" width="100">
                      <template slot-scope="scope">
                          <el-tooltip effect="dark" content="修改" placement="top">
                              <el-button circle type="warning" icon="el-icon-edit" size="mini" @click="edit(scope.row)"></el-button>
                          </el-tooltip>
                          <el-tooltip effect="dark" content="删除" placement="top">
                              <el-button circle type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)"></el-button>
                          </el-tooltip>
                      </template>
                  </el-table-column>
              </MyTable>
          </template>
      </xh-filter-layout>
    <xh-dialog :title="dialog.title" :visible.sync="dialog.visible" width="70%" height="90%" :close-on-click-modal="false" @closed="closeModal">
      <HomeCloudEdit ref="editRef" v-if="dialog.visible" :data="dialog.editRow" :CloudType="CloudType" @closeModal="closeModal" center></HomeCloudEdit>
    </xh-dialog>
  </div>
</template>
<script>
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
import MyPanel from "@/components/Pannel/Pannel";
import MyTable from "@/components/XhComponents/XhPageTable";
import HomeCloudEdit from "./components/HomeCloudEdit";
    export default {
        components: { XhFilterLayout, MyPanel, MyTable, HomeCloudEdit },
        data() {
            return {
                title: '',
                form: {
                    cloud_type:""
                },
                table: {
                    method: "POST",
                    url: "/HomeCloud/getData",
                },
                dialog: {
                    title: "添加",
                    visible: false,
                    editRow: {}
                },
                CloudType:[]
            }
        },
        methods: {
            query() {
                this.$refs.mytable.reload();
            },
            edit(row) {
                let that = this;
                if (row == null) {
                    that.dialog.title = "添加";
                    that.dialog.editRow = {
                        id: that.$util.guid(),
                        system_name: "",
                        cloud_type: "1",
                        system_content: "",
                        sort: 1
                    };
                } else {
                    that.dialog.title = "修改";
                    that.dialog.editRow = row;
                }
                that.dialog.visible = true;
            },
            //关闭弹出页面
            closeModal() {
                this.dialog.visible = false;
                this.$nextTick(function () { this.query(); });
            },
            deleteRow(row) {
                let that = this;
                that.$confirm("删除后无法恢复, 确定要删除吗?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" })
                    .then(() => {
                        that.$api.post("/HomeCloud/deleteData", { id: row.id },
                            function (res) {
                                if (res.code === "200") {
                                    that.query();
                                    that.$message.success("删除成功");
                                } else {
                                    that.$message.error("删除失败");
                                }
                            },
                            function (res) {
                                //that.$message.error("服务器异常，删除出错");
                            }
                        );
                    })
                    .catch(() => {
                    });
            },
            getCloudType() {
                let that = this;
                that.$api.post("/Main/getDictionaryList", { catalogCode:"CloudType" },
                    function (res) {
                        if (res.code === "200") {
                            that.CloudType=res.data;
                        }
                    },
                    function (res) {
                        that.$message.error("服务异常，信息出错");
                    }
                );     
            },
        },
        computed: {},
        mounted() { },
        created() { this.getCloudType(); },
        watch: {},
    }
</script>
